// Utilitare comune pentru campuri de cantitate/pret: utilizatorii romani tasteaza
// de obicei virgula ca separator zecimal, dar valorile "curate" (fara zecimale)
// trebuie sa arate ca niste intregi simple, nu ca "5.000".

// Filtreaza ce se tasteaza intr-un camp de cantitate/pret: doar cifre si UN singur
// separator zecimal (virgula sau punct, pastrat asa cum a fost tastat - normalizarea
// la punct se face abia la trimiterea catre server, cu normalizeazaNumar).
export function filtreazaCantitate(text) {
  let v = text.replace(/[^0-9.,]/g, '');
  const primaVirgula = v.search(/[.,]/);
  if (primaVirgula !== -1) {
    v = v.slice(0, primaVirgula + 1) + v.slice(primaVirgula + 1).replace(/[.,]/g, '');
  }
  return v;
}

// Converteste ce a tastat utilizatorul (posibil cu virgula) intr-un string numeric
// standard, cu punct, gata de trimis catre backend (care il transforma in BigDecimal).
export function normalizeazaNumar(text) {
  if (text == null) return text;
  return String(text).trim().replace(',', '.');
}

// Afiseaza o cantitate/valoare numerica fara zecimale inutile (5 in loc de 5.000),
// dar pastrand pana la 3 zecimale semnificative cand exista, cu virgula romaneasca.
export function formatCantitate(valoare) {
  if (valoare == null || valoare === '') return '';
  const n = Number(valoare);
  if (Number.isNaN(n)) return String(valoare);
  return n.toLocaleString('ro-RO', { maximumFractionDigits: 3 });
}
